export default __webpack_public_path__ + "locales/tr/Common.json?hash=72cf304559a19252967efd31eade662d";